import React, { useState, useEffect } from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import BookmarksForm from 'app/components/BookmarksForm';
import BookmarksGenerateForm from 'app/components/BookmarksGenerateForm';
import BookmarkTableContainer from 'app/containers/BookmarkTableContainer';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import NavMenu from 'components/NavMenu';
import Paper from '@material-ui/core/Paper';
import TextEvents from 'app/components/TextEvents';
import { Table, Drawer, Button } from 'antd'
import { useStyles, styles } from './BookmarksScreenStyles';

import { clearCommunicationProgramDetails } from 'app/actions/CommunicationProgramActions';
import { clearBookmark, clearBookmarkPreview, fetchBookmark } from 'app/actions/BookmarkActions';
import { useDispatch } from 'react-redux';

export default function BookmarksScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [filter, setFilter] = useState([]);
    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});
    const [PDFData, setPDFData] = useState({});
    const [isVisible, setVisible] = useState();
    const [isVisiblePDF, setVisiblePDF] = useState();
    const data = {
        subdirection: '3',
        offset: 0,
        limit: 25
    }
    useEffect(() => {
        return () => {
            dispatch(clearBookmark());
        }
    }, []);
    const onBack = () => {
        dispatch(clearBookmark());
        dispatch(fetchBookmark(data));
        dispatch(clearCommunicationProgramDetails());
        dispatch(clearBookmarkPreview());
        setVisible(false);
    }

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isManag={true} header='Administración de Bookmarks' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label='Breadcrumb'>
                        <Link color='inherit' disabled>
                            Gestión
                        </Link>
                        <TextEvents
                            text={'Administración de Bookmarks'}
                            color='cotemar'
                            size='subtitle'
                            weight='bold'
                        />
                    </Breadcrumbs>
                </div>
                <Paper className={classes.rootPaper}>
                    <BookmarkTableContainer setPDFData={setPDFData} setVisiblePDF={setVisiblePDF} classes={classes} filter={filter} sorter={sorter} setSorter={setSorter} pagination={pagination} setPagination={setPagination} formData={formData}>
                        {(params) => {
                            return (
                                <div>
                                    <BookmarksForm
                                        classes={classes}
                                        filter={filter}
                                        formData={formData}
                                        pagination={pagination}
                                        setFilter={setFilter}
                                        setFormData={setFormData}
                                        sorter={sorter}
                                        styles={styles}
                                        setVisible={setVisible}
                                        bookmarksFilters={params.bookmarksFilters}
                                    ></BookmarksForm>
                                    <Table
                                        loading={params.isLoading}
                                        rowKey={item => String(item.idBookMark)}
                                        columns={params.cols}
                                        dataSource={params.bookmarks}
                                        onChange={params.handleTableChange}
                                        pagination={pagination}
                                        scroll={{ x: 'min-content', y: (height - 395) }}
                                        size={"small"}
                                    // scroll={{ y: 700, x: 1300 }}
                                    />
                                </div>
                            )
                        }}
                    </BookmarkTableContainer>

                </Paper>
            </div>
            <Drawer
                title={<div className={classes.headerDrawer}><Button onClick={onBack} type='link' icon='left'>Regresar </Button><TextEvents
                    text={'Generación de Bookmark'}
                    color='dark'
                    size='label'
                    weight='bold'
                /></div>}
                width={'100%'}
                bodyStyle={{ height: '90%' }}
                closable={false}
                onClose={() => setVisible(false)}
                visible={isVisible}
                destroyOnClose={true}
            >
                <BookmarksGenerateForm
                    onBack={onBack}
                    filter={filter}
                    sorter={sorter}
                    classes={classes}
                    pagination={pagination}
                    styles={styles}></BookmarksGenerateForm>
            </Drawer>
            {isVisiblePDF ? <Drawer
                title={<div className={classes.headerDrawer}><Button onClick={() => setVisiblePDF(false)} type='link' icon='left'>Regresar </Button><TextEvents
                    text={'Visualización de pdf'}
                    color='dark'
                    size='label'
                    weight='bold'
                /></div>}
                placement="right"
                width={'100%'}
                bodyStyle={{ height: '90%' }}
                closable={true}
                onClose={() => setVisiblePDF(false)}
                visible={isVisiblePDF}
            >
                <div style={{ height: '100%', display: 'flex' }}>
                    <embed src={PDFData.bookmarkUrl} width="100%" height="100%" type="application/pdf" />
                </div>
            </Drawer> : ''}
        </div>
    )
}
